import { useState } from 'react'
import Jansirani from '../assets/images/Jansirani.png'
import jeeva from '../assets/images/Jeeva.png'
import Karthikeyan from '../assets/images/Karthikeyan.png'
import NiraimozhiPoongundran from '../assets/images/NiraimozhiPoongundran.png'
import RajhKumar from '../assets/images/RajhKumar.png'
// import Vidhya from '../assets/images/Vidhya.png'
// import Veronica from '../assets/images/Veronica.png'
// import Kajalkumari from '../assets/images/KajalKumari.png'
import dira from '../assets/images/DIRAA.jpg'
import aboutBanner from '../assets/logo/Our Story_ Hampi at Golden Hour.png'
import { Icon } from '../components/Icons'
import { SectionHead } from '../components/UI'

// const STATS = [
//   { val: '13+', label: 'Years of Experience' },
//   { val: '10,000+', label: 'Travellers Served' },
//   { val: '100+', label: 'Corporate Clients' },
//   { val: '3,000+', label: 'B2B Partners' },
//   { val: '1,000+', label: 'International Bookings' },
//   { val: '6+', label: 'Countries' },
// ]

const VALUES = [
  {
    icon: 'shield',
    title: 'Integrity',
    desc: 'We conduct our business with honesty, transparency, and accountability.',
  },
  {
    icon: 'heart',
    title: 'Customer First',
    desc: 'Our customers are at the heart of every decision we make.',
  },
  {
    icon: 'star',
    title: 'Excellence',
    desc: 'We strive for the highest standards in service quality and operational performance.',
  },
  {
    icon: 'globe',
    title: 'Innovation',
    desc: 'We embrace technology and new ideas to enhance the travel experience.',
  },
  {
    icon: 'support',
    title: 'Teamwork',
    desc: 'We believe collaboration and mutual respect drive sustainable success.',
  },
  {
    icon: 'check',
    title: 'Reliability',
    desc: 'We deliver dependable travel solutions with consistency and professionalism.',
  },
  {
    icon: 'inr',
    title: 'Growth',
    desc: 'We are committed to continuous learning, business expansion, and delivering greater value to our clients and partners.',
  },
]

const CERTS = ['IATA Certified', 'RBI Compliant', 'ISO 9001:2015', 'TAAI Member']

const EMPLOYEES = [
  {
    id: 1,
    name: 'Rajhkumar',
    role: 'Founder & Chief Executive Officer',
    image: RajhKumar,
  },
  {
    id: 2,
    name: 'Jeeva.G',
    role: 'Managing Director',
    image: jeeva,
  },
  {
    id: 3,
    name: 'Jansirani',
    role: 'Director',
    image: Jansirani,
  },
  {
    id: 4,
    name: 'Nirai Mozhi Poongundran',
    role: 'General Manager',
    image: NiraimozhiPoongundran,
  },
  {
    id: 5,
    name: 'Karthikeyan',
    role: 'Administrative Executive',
    image: Karthikeyan,
  },
  // {
  //   id: 6,
  //   name: 'Vidhya.S',
  //   role: 'Tour Consultant',
  //   image: Vidhya,
  // },
  // {
  //   id: 7,
  //   name: 'Veronica',
  //   role: 'Tour Consultant',
  //   image: Veronica,
  // },
  // {
  //   id: 8,
  //   name: 'KajalKumari.H',
  //   role: 'Tour Consultant',
  //   image: Kajalkumari,
  // },
]

function EmployeeCard({ emp }) {
  const [hovered, setHovered] = useState(false)
  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        textAlign: 'center',
        transition: 'all 0.3s',
        transform: hovered ? 'translateY(-8px)' : 'translateY(0)',
      }}
    >
      <div
        style={{
          width: '100%',
          paddingBottom: '100%',
          position: 'relative',
          marginBottom: '16px',
          borderRadius: '12px',
          overflow: 'hidden',
          background: '#f5f5f5',
        }}
      >
        <img
          src={emp.image}
          alt={emp.name}
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            transition: 'transform 0.3s',
            transform: hovered ? 'scale(1.05)' : 'scale(1)',
          }}
        />
      </div>
      <h4 style={{ fontSize: '15px', fontWeight: 700, color: '#0d1117', margin: '0 0 6px' }}>
        {emp.name}
      </h4>
      <p style={{ fontSize: '12px', color: 'var(--brand)', fontWeight: 600, margin: 0 }}>
        {emp.role}
      </p>
    </div>
  )
}

function QuoteText({ text, style = {} }) {
  const [hovered, setHovered] = useState(false)
  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        marginBottom: '24px',
        ...style,
      }}
    >
      <p
        style={{
          fontSize: '15px',
          color: hovered ? 'var(--secondary)' : '#2d3748',
          fontStyle: 'italic',
          margin: 0,
          fontWeight: 800,
          lineHeight: 1.7,
          transition: 'color 0.3s ease',
        }}
      >
        <span
          style={{
            color: 'var(--secondary)',
            fontSize: '22px',
            fontFamily: 'Georgia, serif',
            marginRight: '2px',
          }}
        >
          “
        </span>
        {text}
        <span
          style={{
            color: 'var(--secondary)',
            fontSize: '22px',
            fontFamily: 'Georgia, serif',
            marginLeft: '2px',
          }}
        >
          ”
        </span>
      </p>
    </div>
  )
}

function ValueCard({ v }) {
  const [hovered, setHovered] = useState(false)
  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      className="hover-card"
      style={{
        background: '#fff',
        border: '1.5px solid #e2e8f0',
        borderRadius: '12px',
        padding: '26px',
        transition: 'all 0.3s',
      }}
    >
      <div
        style={{
          width: '42px',
          height: '42px',
          background: hovered ? 'rgba(255,182,0,0.1)' : 'var(--brand-lt)',
          borderRadius: '10px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: '14px',
          transition: 'all 0.3s',
        }}
      >
        <Icon name={v.icon} size={20} color={hovered ? 'var(--secondary)' : 'var(--brand)'} />
      </div>
      <h4 style={{ fontSize: '15px', fontWeight: 700, color: '#0d1117', margin: '0 0 7px' }}>
        {v.title}
      </h4>
      <p style={{ fontSize: '12px', color: '#6b7a8f', lineHeight: 1.65, margin: 0 }}>{v.desc}</p>
    </div>
  )
}

export default function About() {
  return (
    <div className="page-enter">
      {/* Hero Banner */}
      <div
        style={{
          position: 'relative',
          width: '100%',
          overflow: 'hidden',
          background: '#0d1117',
          boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
        }}
      >
        <img
          src={aboutBanner}
          alt="Our Story - About DIRA Holidays"
          style={{
            width: '100%',
            height: 'auto',
            maxHeight: '440px',
            objectFit: 'cover',
            display: 'block',
          }}
        />
      </div>

      <div style={{ maxWidth: '1100px', margin: '0 auto', padding: '60px 32px' }}>
        {/* Brand story */}
        <div style={{ marginBottom: '80px' }}>
          <div
            className="about-story-grid"
            style={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gap: '48px',
              alignItems: 'center',
              marginBottom: '40px',
            }}
          >
            <div>
              <h3
                style={{
                  fontSize: '24px',
                  fontWeight: 800,
                  color: '#0d1117',
                  marginBottom: '16px',
                }}
              >
                Company Overview
              </h3>
              <p
                style={{
                  fontSize: '13px',
                  color: '#6b7a8f',
                  lineHeight: 1.85,
                  marginBottom: '14px',
                }}
              >
                DIRA HOLIDAYS is an internationally focused travel and tourism company providing
                comprehensive travel solutions for leisure travellers, corporations, educational
                institutions, and travel partners.
              </p>
              <p
                style={{
                  fontSize: '13px',
                  color: '#6b7a8f',
                  lineHeight: 1.85,
                  marginBottom: '14px',
                }}
              >
                Established on 16 December 2013, the organisation has continuously evolved to meet
                the changing needs of the travel industry. Through strategic expansion, innovation,
                and strong global partnerships, DIRA HOLIDAYS has become a trusted name in
                destination management, corporate travel, holiday planning, and tourism services.
              </p>
              <p
                style={{
                  fontSize: '13px',
                  color: '#6b7a8f',
                  lineHeight: 1.85,
                  marginBottom: '24px',
                }}
              >
                Today, our operations extend across India, Malaysia, Singapore, Sri Lanka, Thailand,
                and Japan, supported by an experienced leadership team and a reliable international
                partner network. We are committed to delivering exceptional travel experiences
                through professionalism, transparency, and customer-focused service.
              </p>
              <QuoteText text="Delivering trusted travel solutions with professionalism, innovation, and personalised service while creating memorable journeys for every client." />
              <div style={{ display: 'flex', gap: '14px', flexWrap: 'wrap' }}>
                {CERTS.map((c) => (
                  <div key={c} style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <Icon name="check" size={14} color="var(--brand)" />
                    <span style={{ fontSize: '12px', fontWeight: 600, color: '#3d4a5c' }}>{c}</span>
                  </div>
                ))}
              </div>
            </div>
            <div
              style={{
                borderRadius: '16px',
                overflow: 'hidden',
                border: '1.5px solid #e2e8f0',
                boxShadow: '0 8px 32px rgba(0,0,0,0.10)',
              }}
            >
              <img
                src={dira}
                alt="DIRA HOLIDAYS"
                style={{ width: '100%', height: 'auto', display: 'block' }}
              />
            </div>
          </div>

          <div
            style={{
              background: '#f8f9fa',
              padding: '40px',
              borderRadius: '16px',
              border: '1px solid #e2e8f0',
            }}
          >
            <h3
              style={{ fontSize: '24px', fontWeight: 800, color: '#0d1117', marginBottom: '16px' }}
            >
              Our Story
            </h3>
            <h4
              style={{
                fontSize: '16px',
                fontWeight: 700,
                color: 'var(--brand)',
                marginBottom: '16px',
              }}
            >
              Building a Legacy Through Vision, Innovation & Transformation
            </h4>
            <QuoteText text="Every successful organization is built upon a journey of continuous learning, strategic evolution, and the courage to embrace change." />

            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
                gap: '30px',
              }}
            >
              <div>
                <p
                  style={{
                    fontSize: '13px',
                    color: '#6b7a8f',
                    lineHeight: 1.85,
                    marginBottom: '14px',
                  }}
                >
                  The story of DIRA HOLIDAYS GROUP began on 16 December 2013, when our Founder,
                  Rajhkumar, established GOH Tours & Travels in the historic coastal town of
                  Nagapattinam, Tamil Nadu, India. What started as a modest travel agency was driven
                  by a clear purpose—to provide honest, reliable, and customer-focused travel
                  services while making quality travel accessible to everyone.
                </p>
                <p
                  style={{
                    fontSize: '13px',
                    color: '#6b7a8f',
                    lineHeight: 1.85,
                    marginBottom: '14px',
                  }}
                >
                  As the business gained the trust of travellers and expanded its customer base, new
                  opportunities emerged beyond India. Recognising the growing demand for
                  international travel and destination management, the company underwent its first
                  strategic transformation and adopted the name Travelers Dream Destination.
                </p>
                <p style={{ fontSize: '13px', color: '#6b7a8f', lineHeight: 1.85 }}>
                  During this period, Rajhkumar was appointed as a Director of Travelers Dream
                  Destination Sdn. Bhd., Malaysia, where he later assumed the role of Managing
                  Director. This international leadership experience strengthened the company’s
                  expertise in cross-border tourism, destination management, and strategic business
                  partnerships.
                </p>
              </div>
              <div>
                <p
                  style={{
                    fontSize: '13px',
                    color: '#6b7a8f',
                    lineHeight: 1.85,
                    marginBottom: '14px',
                  }}
                >
                  As the company continued to grow, the Indian operations were rebranded in 2019 as
                  Maayon Travels. The new identity represented a modern, customer-friendly approach
                  while maintaining the same commitment to quality, integrity, and personalised
                  service.
                </p>
                <p
                  style={{
                    fontSize: '13px',
                    color: '#6b7a8f',
                    lineHeight: 1.85,
                    marginBottom: '14px',
                  }}
                >
                  The COVID-19 pandemic brought unprecedented challenges to the global tourism
                  industry, requiring businesses around the world to rethink their strategies.
                  Rather than allowing these challenges to define our future, we embraced
                  transformation, restructured our operations, strengthened our digital
                  capabilities, and prepared for a new era of travel.
                </p>
                <p style={{ fontSize: '13px', color: '#6b7a8f', lineHeight: 1.85 }}>
                  Today, DIRA HOLIDAYS proudly serves as the flagship brand of our organisation,
                  delivering comprehensive travel solutions across India, Malaysia, Singapore, Sri
                  Lanka, Thailand, and Japan. With more than 13 years of industry experience, we
                  continue to grow with a commitment to innovation, service excellence, and customer
                  satisfaction.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Quote */}
        <QuoteText
          text="Your Journey. Our Commitment."
          style={{ textAlign: 'center', marginBottom: '80px', padding: '30px' }}
        />

        {/* Our Journey */}
        <div style={{ marginBottom: '60px' }}>
          <SectionHead eyebrow="Our Journey" title="A Legacy Through Vision & Transformation" />
          <div className="timeline-wrap">
            {[
              { year: '2013', desc: 'GOH Tours & Travels founded in Nagapattinam, India.' },
              {
                year: '2014 – 2016',
                desc: 'Travelers Dream Destination — expansion of domestic and international operations.',
              },
              {
                year: '2017 – 2019',
                desc: 'Director & Managing Director, Travelers Dream Destination Sdn. Bhd., Malaysia.',
              },
              {
                year: '2019',
                desc: 'Maayon Travels — rebranding and continued international growth.',
              },
              { year: '2020', desc: 'DIRA HOLIDAYS GROUP established with expanded vision.' },
              {
                year: '2021 – 2026',
                desc: 'International expansion and strengthening global operations across Asia.',
              },
              {
                year: 'Today',
                desc: 'A trusted travel brand with ongoing growth across 6+ countries worldwide.',
              },
            ].map((item, i) => (
              <div key={i} className={`timeline-item ${i % 2 === 0 ? 'left' : 'right'}`}>
                <div className="timeline-dot"></div>
                <div
                  style={{
                    background: '#fff',
                    border: '1.5px solid #e2e8f0',
                    borderRadius: '12px',
                    padding: '20px 24px',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.03)',
                  }}
                >
                  <h4
                    style={{
                      color: 'var(--brand)',
                      fontSize: '18px',
                      fontWeight: 800,
                      margin: '0 0 8px',
                    }}
                  >
                    {item.year}
                  </h4>
                  <p style={{ fontSize: '14px', color: '#6b7a8f', margin: 0, lineHeight: 1.6 }}>
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Vision and Mission */}
        <div
          style={{
            marginBottom: '60px',
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '40px',
          }}
        >
          <div>
            <h3
              style={{ fontSize: '24px', fontWeight: 800, color: '#0d1117', marginBottom: '16px' }}
            >
              Our Vision
            </h3>
            <p style={{ fontSize: '14px', color: '#6b7a8f', lineHeight: 1.8 }}>
              To become one of Asia's most trusted and innovative travel and destination management
              companies, delivering exceptional travel experiences through global partnerships,
              operational excellence, and customer centric solutions.
            </p>
          </div>
          <div>
            <h3
              style={{ fontSize: '24px', fontWeight: 800, color: '#0d1117', marginBottom: '16px' }}
            >
              Our Mission
            </h3>
            <ul
              style={{ fontSize: '14px', color: '#6b7a8f', lineHeight: 1.8, paddingLeft: '20px' }}
            >
              <li style={{ marginBottom: '10px' }}>
                To provide reliable, seamless, and personalised travel solutions for leisure,
                corporate, and institutional clients.
              </li>
              <li style={{ marginBottom: '10px' }}>
                To build long-term relationships through integrity, professionalism, and outstanding
                customer service.
              </li>
              <li>
                To continuously innovate and expand our global network, creating memorable journeys
                that exceed customer expectations.
              </li>
            </ul>
          </div>
        </div>

        {/* Achievements & Milestones */}
        <div style={{ marginBottom: '80px' }}>
          <div style={{ textAlign: 'center', marginBottom: '40px' }}>
            <SectionHead
              eyebrow="Achievements & Milestones"
              title="A Journey of Growth, Trust & Excellence"
            />
            <p
              style={{
                fontSize: '14px',
                color: '#6b7a8f',
                maxWidth: '700px',
                margin: '0 auto',
                lineHeight: 1.6,
              }}
            >
              Since our establishment in 2013, DIRA Holidays has grown into a trusted travel company
              serving individuals, families, corporate clients, and travel partners across Asia.
              Every milestone reflects our commitment to delivering exceptional travel experiences,
              building lasting partnerships, and continuously expanding our reach.
            </p>
          </div>

          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
              gap: '20px',
            }}
          >
            {[
              { icon: 'clock', title: '13+', desc: 'Years of Experience' },
              { icon: 'users', title: '10,000+', desc: 'Travellers Served' },
              { icon: 'city', title: '100+', desc: 'Corporate Clients' },
              { icon: 'briefcase', title: '3,000+', desc: 'B2B Partners' },
              { icon: 'plane', title: '1,000+', desc: 'International Bookings' },
              { icon: 'globe', title: '6+', desc: 'Countries' },
              { icon: 'hotel', title: 'Global', desc: 'Airline & Hotel Partners' },
              { icon: 'star', title: 'Expert', desc: 'Leadership Team' },
            ].map((m, i) => (
              <div
                key={i}
                style={{
                  background: '#fff',
                  border: '1.5px solid #e2e8f0',
                  borderRadius: '12px',
                  padding: '24px',
                  textAlign: 'center',
                  boxShadow: '0 4px 20px rgba(0,0,0,0.03)',
                }}
              >
                <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '16px' }}>
                  <div
                    style={{
                      width: '52px',
                      height: '52px',
                      background: 'var(--brand-lt)',
                      borderRadius: '10px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <Icon name={m.icon} size={24} color="var(--brand)" />
                  </div>
                </div>
                <h4
                  style={{
                    fontSize: '32px',
                    fontWeight: 800,
                    color: 'var(--brand)',
                    marginBottom: '6px',
                  }}
                >
                  {m.title}
                </h4>
                <p
                  style={{
                    fontSize: '13px',
                    fontWeight: 700,
                    color: '#3d4a5c',
                    margin: 0,
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                  }}
                >
                  {m.desc}
                </p>
              </div>
            ))}
          </div>
          <div style={{ marginTop: '30px' }}>
            <QuoteText
              text="Every milestone reflects our commitment to excellence, every journey inspires our future."
              style={{ textAlign: 'center', marginBottom: 0 }}
            />
          </div>
        </div>

        {/* Values */}
        <SectionHead eyebrow="Our Core Values" title="Principles that Guide Us" />
        <QuoteText
          text="Great journeys begin with exceptional service. My mission is to ensure every traveler experiences professionalism, reliability, and unforgettable memories through DIRA HOLIDAYS."
          style={{ textAlign: 'center' }}
        />
        <div
          className="about-values-grid"
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '18px',
            marginBottom: '80px',
          }}
        >
          {VALUES.map((v) => (
            <ValueCard key={v.title} v={v} />
          ))}
        </div>

        {/* Our Expertise & Services */}
        <div style={{ marginBottom: '80px' }}>
          <SectionHead eyebrow="Our Expertise" title="Comprehensive Travel Solutions" />
          <QuoteText
            text="From planning and documentation to destination management and logistics, DIRA Holidays delivers complete travel solutions with professionalism, reliability, and personalised service."
            style={{ textAlign: 'center' }}
          />

          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
              gap: '20px',
            }}
          >
            <div
              style={{
                padding: '24px',
                border: '1.5px solid #e2e8f0',
                borderRadius: '12px',
                background: '#fff',
              }}
            >
              <h4
                style={{
                  fontSize: '16px',
                  fontWeight: 800,
                  color: '#0d1117',
                  marginBottom: '16px',
                }}
              >
                Destination Management (DMC)
              </h4>
              <QuoteText
                text="Local Expertise. Global Standards. Memorable Journeys."
                style={{ marginBottom: 0 }}
              />
            </div>
            <div
              style={{
                padding: '24px',
                border: '1.5px solid #e2e8f0',
                borderRadius: '12px',
                background: '#fff',
              }}
            >
              <h4
                style={{
                  fontSize: '16px',
                  fontWeight: 800,
                  color: '#0d1117',
                  marginBottom: '16px',
                }}
              >
                Corporate & MICE Travel
              </h4>
              <QuoteText
                text="Empowering businesses with reliable, efficient, and seamless corporate travel solutions."
                style={{ marginBottom: 0 }}
              />
            </div>
            <div
              style={{
                padding: '24px',
                border: '1.5px solid #e2e8f0',
                borderRadius: '12px',
                background: '#fff',
              }}
            >
              <h4
                style={{
                  fontSize: '16px',
                  fontWeight: 800,
                  color: '#0d1117',
                  marginBottom: '16px',
                }}
              >
                Global Presence
              </h4>
              <QuoteText
                text="Expanding our footprint across Asia while connecting travellers to destinations around the world through trusted partnerships and strategic collaborations."
                style={{ marginBottom: 0 }}
              />
            </div>
            <div
              style={{
                padding: '24px',
                border: '1.5px solid #e2e8f0',
                borderRadius: '12px',
                background: '#fff',
              }}
            >
              <h4
                style={{
                  fontSize: '16px',
                  fontWeight: 800,
                  color: '#0d1117',
                  marginBottom: '16px',
                }}
              >
                Airline Networks
              </h4>
              <QuoteText
                text="Working with leading airline networks to deliver competitive fares and seamless travel experiences."
                style={{ marginBottom: 0 }}
              />
            </div>
            <div
              style={{
                padding: '24px',
                border: '1.5px solid #e2e8f0',
                borderRadius: '12px',
                background: '#fff',
              }}
            >
              <h4
                style={{
                  fontSize: '16px',
                  fontWeight: 800,
                  color: '#0d1117',
                  marginBottom: '16px',
                }}
              >
                Hospitality Partners
              </h4>
              <QuoteText
                text="Partnering with trusted hospitality providers to deliver comfort, quality, and exceptional guest experiences."
                style={{ marginBottom: 0 }}
              />
            </div>
          </div>
        </div>

        {/* Our Strength */}
        <SectionHead
          eyebrow="OUR STRENGTH"
          title="Building Excellence Through Experience, Innovation & Trust"
        />
        <p
          style={{
            textAlign: 'center',
            fontSize: '14px',
            color: '#6b7a8f',
            marginBottom: '40px',
            maxWidth: '900px',
            margin: '0 auto 40px',
            lineHeight: 1.8,
          }}
        >
          At DIRA Holidays, our strength lies in years of industry expertise, a growing
          international network, and an unwavering commitment to delivering exceptional travel
          experiences. Every journey we plan is backed by professionalism, trusted partnerships, and
          customer-focused service.
        </p>
        <div
          style={{
            marginBottom: '40px',
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '30px',
          }}
        >
          {[
            {
              icon: 'clock',
              title: '13+ Years of Industry Experience',
              desc: 'Delivering trusted travel solutions since 2013 with proven expertise in leisure, corporate, and international travel.',
            },
            {
              icon: 'globe',
              title: 'Global Network Across Asia',
              desc: 'Strong operational presence and strategic partnerships across India, Malaysia, Singapore, Sri Lanka, Thailand, and Japan.',
            },
            {
              icon: 'users',
              title: 'Experienced Leadership Team',
              desc: 'A dedicated team of travel professionals committed to operational excellence and customer satisfaction.',
            },
            {
              icon: 'briefcase',
              title: 'Extensive B2B Partner Network',
              desc: 'Over 3,000 travel agents, suppliers, hotels, and destination partners supporting seamless travel experiences.',
            },
            {
              icon: 'city',
              title: 'Trusted by Corporate Clients',
              desc: 'Preferred travel partner for businesses, educational institutions, organizations, and government sectors.',
            },
            {
              icon: 'heart',
              title: 'Customer-First Philosophy',
              desc: 'Every service is designed with personalized attention, reliability, and long-term customer relationships in mind.',
            },
            {
              icon: 'phone',
              title: 'Technology-Driven Operations',
              desc: 'Modern booking systems, digital communication, and streamlined processes for faster and more efficient service.',
            },
            {
              icon: 'inr',
              title: 'Competitive & Transparent Pricing',
              desc: 'Value-driven travel solutions with no hidden costs and flexible packages tailored to every budget.',
            },
            {
              icon: 'support',
              title: 'Dedicated Customer Support',
              desc: 'Professional assistance before, during, and after every journey to ensure a smooth travel experience.',
            },
            {
              icon: 'shield',
              title: 'Compliance & Professional Standards',
              desc: 'Committed to ethical business practices, regulatory compliance, and maintaining the highest standards of professionalism.',
            },
          ].map((m, i) => (
            <ValueCard key={i} v={m} />
          ))}
        </div>
        <div style={{ marginBottom: '80px' }}>
          <QuoteText
            text="Building trust through expertise, partnerships, and exceptional service."
            style={{ textAlign: 'center' }}
          />
        </div>

        {/* Future Vision */}
        <div style={{ marginBottom: '80px' }}>
          <SectionHead eyebrow="Future Vision" title="Roadmap 2026–2035" />
          <p
            style={{
              textAlign: 'center',
              fontSize: '14px',
              color: '#6b7a8f',
              marginBottom: '40px',
              maxWidth: '800px',
              margin: '0 auto 40px',
            }}
          >
            At DIRA Holidays, our vision extends beyond expanding destinations—we are committed to
            building a globally recognized travel brand driven by innovation, operational
            excellence, and exceptional customer experiences.
          </p>
          <div className="timeline-wrap">
            {[
              {
                year: '2026',
                title: 'Strengthening Regional Operations',
                desc: 'Enhance operational excellence across offices in India, Malaysia, Singapore, Thailand, Sri Lanka, and Japan.',
              },
              {
                year: '2027',
                title: 'Expanding Global Partnerships',
                desc: 'Strengthen collaborations with airlines, hotels, tourism boards, and international travel partners.',
              },
              {
                year: '2028',
                title: 'Digital Transformation',
                desc: 'Launch integrated online booking platform, mobile solutions, and advanced CRM systems.',
              },
              {
                year: '2029',
                title: 'Expanding Worldwide Destinations',
                desc: 'Broaden portfolio to Europe, Middle East, Americas, Africa, and Oceania.',
              },
              {
                year: '2030',
                title: 'Serving 50,000+ Travellers',
                desc: 'Reach the milestone of 50,000 satisfied travellers through continued service excellence.',
              },
              {
                year: '2032',
                title: 'Global Brand Recognition',
                desc: 'Establish DIRA Holidays as a preferred travel partner across Asia.',
              },
              {
                year: '2035',
                title: 'A Leading Global Travel Brand',
                desc: "Become one of Asia's most trusted travel companies for innovative solutions and world-class DMC services.",
              },
            ].map((item, i) => (
              <div key={i} className={`timeline-item ${i % 2 === 0 ? 'left' : 'right'}`}>
                <div className="timeline-dot"></div>
                <div
                  style={{
                    background: '#fff',
                    border: '1.5px solid #e2e8f0',
                    borderRadius: '12px',
                    padding: '20px 24px',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.03)',
                  }}
                >
                  <div style={{ marginBottom: '8px' }}>
                    <h4
                      style={{
                        color: 'var(--brand)',
                        fontSize: '18px',
                        fontWeight: 800,
                        margin: '0 12px 0 0',
                        display: 'inline-block',
                      }}
                    >
                      {item.year}
                    </h4>
                    <h5
                      style={{
                        fontSize: '15px',
                        fontWeight: 700,
                        color: '#0d1117',
                        margin: 0,
                        display: 'inline-block',
                      }}
                    >
                      {item.title}
                    </h5>
                  </div>
                  <p style={{ fontSize: '14px', color: '#6b7a8f', margin: 0, lineHeight: 1.6 }}>
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
          <div style={{ marginTop: '40px', textAlign: 'center' }}>
            <h4
              style={{ fontSize: '18px', fontWeight: 800, color: '#0d1117', marginBottom: '12px' }}
            >
              Our Vision for Tomorrow
            </h4>
            <p
              style={{
                fontSize: '14px',
                color: '#6b7a8f',
                maxWidth: '800px',
                margin: '0 auto 20px',
              }}
            >
              As we continue to grow, DIRA Holidays remains committed to connecting people,
              cultures, and destinations through trusted partnerships, innovative technology, and
              personalized travel experiences that inspire confidence and create lasting memories.
            </p>
            <QuoteText
              text="Today we connect destinations. Tomorrow we inspire the world to explore."
              style={{ textAlign: 'center', marginBottom: 0 }}
            />
          </div>
        </div>

        {/* Licences & Registrations */}
        <div style={{ marginBottom: '80px' }}>
          <SectionHead
            eyebrow="Licences & Registrations"
            title="Committed to Compliance & Professional Excellence"
          />
          <p
            style={{
              textAlign: 'center',
              fontSize: '14px',
              color: '#6b7a8f',
              marginBottom: '24px',
              maxWidth: '800px',
              margin: '0 auto',
            }}
          >
            DIRA Holidays maintains full regulatory compliance across all markets we operate in,
            ensuring our clients and partners can engage with confidence in our professional
            standards and legal standing.
          </p>
          <QuoteText
            text="Building confidence through compliance, integrity, and professional standards."
            style={{ textAlign: 'center' }}
          />
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
              gap: '30px',
            }}
          >
            <div style={{ background: '#f8f9fa', padding: '24px', borderRadius: '12px' }}>
              <h4
                style={{
                  fontSize: '18px',
                  fontWeight: 800,
                  color: 'var(--brand)',
                  marginBottom: '16px',
                  borderBottom: '2px solid #e2e8f0',
                  paddingBottom: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                }}
              >
                <img
                  src="https://flagcdn.com/in.svg"
                  alt="India"
                  style={{
                    width: '28px',
                    height: '20px',
                    objectFit: 'cover',
                    borderRadius: '3px',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                  }}
                />{' '}
                India
              </h4>
              <ul
                style={{
                  listStyle: 'none',
                  padding: 0,
                  margin: 0,
                  fontSize: '13px',
                  color: '#3d4a5c',
                  lineHeight: 1.8,
                }}
              >
                <li
                  style={{
                    fontWeight: 700,
                    color: '#0d1117',
                    marginTop: '8px',
                    marginBottom: '4px',
                  }}
                >
                  Business Registrations
                </li>
                <li>• GST Registration</li>
                <li>• MSME Registration</li>
                <li>• Permanent Account Number (PAN)</li>
                <li>• Trade Licence</li>
                <li>• Other applicable statutory registrations</li>
                <li
                  style={{
                    fontWeight: 700,
                    color: '#0d1117',
                    marginTop: '12px',
                    marginBottom: '4px',
                  }}
                >
                  Industry Certifications
                </li>
                <li>• IATA Accreditation</li>
                <li>• Additional tourism and industry registrations (As Applicable)</li>
              </ul>
            </div>
            <div style={{ background: '#f8f9fa', padding: '24px', borderRadius: '12px' }}>
              <h4
                style={{
                  fontSize: '18px',
                  fontWeight: 800,
                  color: 'var(--brand)',
                  marginBottom: '16px',
                  borderBottom: '2px solid #e2e8f0',
                  paddingBottom: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                }}
              >
                <img
                  src="https://flagcdn.com/my.svg"
                  alt="Malaysia"
                  style={{
                    width: '28px',
                    height: '20px',
                    objectFit: 'cover',
                    borderRadius: '3px',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                  }}
                />{' '}
                Malaysia
              </h4>
              <ul
                style={{
                  listStyle: 'none',
                  padding: 0,
                  margin: 0,
                  fontSize: '13px',
                  color: '#3d4a5c',
                  lineHeight: 1.8,
                }}
              >
                <li
                  style={{
                    fontWeight: 700,
                    color: '#0d1117',
                    marginTop: '8px',
                    marginBottom: '4px',
                  }}
                >
                  Business Registrations
                </li>
                <li>• SSM Company Registration</li>
                <li>• Company Incorporation & Statutory Compliance</li>
                <li
                  style={{
                    fontWeight: 700,
                    color: '#0d1117',
                    marginTop: '12px',
                    marginBottom: '4px',
                  }}
                >
                  Tourism & Industry Licences
                </li>
                <li>• MOTAC Tourism Licence</li>
                <li>• Tourism Industry Registration (As Applicable)</li>
              </ul>
            </div>
            <div style={{ background: '#f8f9fa', padding: '24px', borderRadius: '12px' }}>
              <h4
                style={{
                  fontSize: '18px',
                  fontWeight: 800,
                  color: 'var(--brand)',
                  marginBottom: '16px',
                  borderBottom: '2px solid #e2e8f0',
                  paddingBottom: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                }}
              >
                <img
                  src="https://flagcdn.com/sg.svg"
                  alt="Singapore"
                  style={{
                    width: '28px',
                    height: '20px',
                    objectFit: 'cover',
                    borderRadius: '3px',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                  }}
                />{' '}
                Singapore
              </h4>
              <ul
                style={{
                  listStyle: 'none',
                  padding: 0,
                  margin: 0,
                  fontSize: '13px',
                  color: '#3d4a5c',
                  lineHeight: 1.8,
                }}
              >
                <li
                  style={{
                    fontWeight: 700,
                    color: '#0d1117',
                    marginTop: '8px',
                    marginBottom: '4px',
                  }}
                >
                  Business Registrations
                </li>
                <li>• Pte Ltd Company Registration</li>
                <li
                  style={{
                    fontWeight: 700,
                    color: '#0d1117',
                    marginTop: '12px',
                    marginBottom: '4px',
                  }}
                >
                  Tourism Licence
                </li>
                <li>• Tourism Licence (As Applicable)</li>
              </ul>
            </div>
            <div style={{ background: '#f8f9fa', padding: '24px', borderRadius: '12px' }}>
              <h4
                style={{
                  fontSize: '18px',
                  fontWeight: 800,
                  color: 'var(--brand)',
                  marginBottom: '16px',
                  borderBottom: '2px solid #e2e8f0',
                  paddingBottom: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                }}
              >
                <img
                  src="https://flagcdn.com/lk.svg"
                  alt="Sri Lanka"
                  style={{
                    width: '28px',
                    height: '20px',
                    objectFit: 'cover',
                    borderRadius: '3px',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                  }}
                />{' '}
                Sri Lanka
              </h4>
              <ul
                style={{
                  listStyle: 'none',
                  padding: 0,
                  margin: 0,
                  fontSize: '13px',
                  color: '#3d4a5c',
                  lineHeight: 1.8,
                }}
              >
                <li
                  style={{
                    fontWeight: 700,
                    color: '#0d1117',
                    marginTop: '8px',
                    marginBottom: '4px',
                  }}
                >
                  Business Registrations
                </li>
                <li>• Pte Ltd Company Registration</li>
                <li
                  style={{
                    fontWeight: 700,
                    color: '#0d1117',
                    marginTop: '12px',
                    marginBottom: '4px',
                  }}
                >
                  Tourism Licence
                </li>
                <li>• Tourism Licence (As Applicable)</li>
              </ul>
            </div>
            <div style={{ background: '#f8f9fa', padding: '24px', borderRadius: '12px' }}>
              <h4
                style={{
                  fontSize: '18px',
                  fontWeight: 800,
                  color: 'var(--brand)',
                  marginBottom: '16px',
                  borderBottom: '2px solid #e2e8f0',
                  paddingBottom: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                }}
              >
                <img
                  src="https://flagcdn.com/th.svg"
                  alt="Thailand"
                  style={{
                    width: '28px',
                    height: '20px',
                    objectFit: 'cover',
                    borderRadius: '3px',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                  }}
                />{' '}
                Thailand
              </h4>
              <ul
                style={{
                  listStyle: 'none',
                  padding: 0,
                  margin: 0,
                  fontSize: '13px',
                  color: '#3d4a5c',
                  lineHeight: 1.8,
                }}
              >
                <li
                  style={{
                    fontWeight: 700,
                    color: '#0d1117',
                    marginTop: '8px',
                    marginBottom: '4px',
                  }}
                >
                  Business Registrations
                </li>
                <li>• Business Registration</li>
              </ul>
            </div>
            <div style={{ background: '#f8f9fa', padding: '24px', borderRadius: '12px' }}>
              <h4
                style={{
                  fontSize: '18px',
                  fontWeight: 800,
                  color: 'var(--brand)',
                  marginBottom: '16px',
                  borderBottom: '2px solid #e2e8f0',
                  paddingBottom: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                }}
              >
                <img
                  src="https://flagcdn.com/jp.svg"
                  alt="Japan"
                  style={{
                    width: '28px',
                    height: '20px',
                    objectFit: 'cover',
                    borderRadius: '3px',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                  }}
                />{' '}
                Japan
              </h4>
              <ul
                style={{
                  listStyle: 'none',
                  padding: 0,
                  margin: 0,
                  fontSize: '13px',
                  color: '#3d4a5c',
                  lineHeight: 1.8,
                }}
              >
                <li
                  style={{
                    fontWeight: 700,
                    color: '#0d1117',
                    marginTop: '8px',
                    marginBottom: '4px',
                  }}
                >
                  Business Registrations
                </li>
              </ul>
            </div>
          </div>

          <div style={{ textAlign: 'center', maxWidth: '800px', margin: '40px auto 0' }}>
            <h4
              style={{
                fontSize: '18px',
                fontWeight: 800,
                color: 'var(--brand)',
                marginBottom: '16px',
              }}
            >
              Our Commitment
            </h4>
            <p style={{ fontSize: '14px', color: '#6b7a8f', lineHeight: 1.8, margin: 0 }}>
              We continuously strengthen our regulatory compliance and pursue internationally
              recognized certifications to enhance service quality, operational excellence, and
              customer confidence across our markets.
            </p>
          </div>
        </div>

        {/* Our Team */}
        <SectionHead eyebrow="Our Team" title="Meet The Experts Behind Your Journey" />
        <QuoteText
          text="Success is built on vision, strengthened by perseverance, and measured by the positive impact we create for our customers, our people, and the communities we serve."
          style={{ textAlign: 'center' }}
        />

        <div style={{ marginBottom: '80px' }}>
          {/* First Row - 3 Members */}
          <div
            className="about-team-grid-3"
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(3, 1fr)',
              gap: '24px',
              maxWidth: '780px',
              margin: '0 auto 24px',
            }}
          >
            {EMPLOYEES.slice(0, 3).map((emp) => (
              <EmployeeCard key={emp.id} emp={emp} />
            ))}
          </div>

          {/* Second Row - 4 Members */}
          <div
            className="about-team-grid-4"
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(2, minmax(220px, 280px))',
              justifyContent: 'center',
              gap: '24px',
              maxWidth: '620px',
              margin: '0 auto 24px',
            }}
          >
            {EMPLOYEES.slice(3, 7).map((emp) => (
              <EmployeeCard key={emp.id} emp={emp} />
            ))}
          </div>

          {/* Remaining Members */}
          {EMPLOYEES.length > 7 && (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                gap: '24px',
              }}
            >
              {EMPLOYEES.slice(7).map((emp) => (
                <div key={emp.id} style={{ width: '242px' }}>
                  <EmployeeCard emp={emp} />
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Contact Us */}
        <div style={{ marginBottom: '40px' }}>
          <SectionHead eyebrow="Contact Us" title="We're Here to Assist You" />
          <p
            style={{
              textAlign: 'center',
              fontSize: '14px',
              color: '#6b7a8f',
              marginBottom: '24px',
              maxWidth: '800px',
              margin: '0 auto',
            }}
          >
            With a strong operational presence across six countries, DIRA Holidays is committed to
            providing reliable travel solutions and personalized support wherever you are.
          </p>
          <QuoteText
            text="Connecting people, destinations, and opportunities across Asia and beyond."
            style={{ textAlign: 'center' }}
          />
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
              gap: '30px',
            }}
          >
            {[
              {
                country: 'INDIA',
                flag: 'in',
                company: 'Dira HolidayMakers PVT. LTD.',
                address:
                  '5/30, 2nd Floor, Bharathi Salai, Near SRM College, Ramapuram, Chennai - 600 089, TN, India.',
                phone: '+91 709 22 109 22',
                email: 'info@diraholidays.com',
              },
              {
                country: 'MALAYSIA',
                flag: 'my',
                company: 'DIRA HOLIDAYS SDN BHD',
                address: 'No. 46-3, Jln C.M. Yusuf, 30250 Ipoh, Perak.',
                phone: '+60 17-761 1668',
                email: 'info@diraholidays.my',
              },
              {
                country: 'SINGAPORE',
                flag: 'sg',
                company: 'ROAMA TOURS PTE LTD',
                address: '20 Ah Hood Rd, Singapore 329984.',
                phone: '+65 9449 0864',
                email: 'info.sg@diraholidays.com',
              },
              {
                country: 'THAILAND',
                flag: 'th',
                company: 'DIRA GLOBAL RESOURCES',
                address: 'Thanom Tani, Talat Yot, Phra Nakhon, Bangkok 10200, Thailand.',
                phone: '+6 01485 38006',
                email: 'info.th@diraholidays.com',
              },
              {
                country: 'SRI LANKA',
                flag: 'lk',
                company: 'MAAYON SERVICES (PVT) LTD',
                address:
                  '2nd Floor, Bernards Business Park, 106 Dutugemunu St, Dehiwala, Mount Lavinia 10350, Sri Lanka.',
                phone: '+94 76735 1583',
                email: 'info.lk@diraholidays.com',
              },
              {
                country: 'JAPAN',
                flag: 'jp',
                company: 'STARWAVES CORPORATION',
                address: 'Seishincho 2-4-6, Edogawa Ku, Tokyo, Japan-1340087.',
                phone: '+81 706400 1288',
                email: 'info.jp@diraholidays.com',
              },
            ].map((contact, i) => (
              <div
                key={i}
                style={{
                  background: '#fff',
                  border: '1.5px solid #e2e8f0',
                  borderRadius: '12px',
                  padding: '24px',
                  textAlign: 'center',
                  boxShadow: '0 4px 20px rgba(0,0,0,0.03)',
                }}
              >
                <h4
                  style={{
                    fontSize: '18px',
                    fontWeight: 800,
                    color: '#0d1117',
                    marginBottom: '8px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px',
                  }}
                >
                  <img
                    src={`https://flagcdn.com/${contact.flag}.svg`}
                    alt={`${contact.country} Flag`}
                    style={{
                      width: '28px',
                      height: '20px',
                      objectFit: 'cover',
                      borderRadius: '3px',
                      boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                    }}
                  />
                  {contact.country}
                </h4>
                <h5
                  style={{
                    fontSize: '13px',
                    fontWeight: 700,
                    color: 'var(--brand)',
                    marginBottom: '16px',
                  }}
                >
                  {contact.company}
                </h5>
                <p
                  style={{
                    fontSize: '12px',
                    color: '#6b7a8f',
                    lineHeight: 1.6,
                    marginBottom: '12px',
                  }}
                >
                  {contact.address}
                </p>
                <p
                  style={{
                    fontSize: '12px',
                    color: '#0d1117',
                    fontWeight: 600,
                    marginBottom: '4px',
                  }}
                >
                  Phone:{' '}
                  <a
                    href={`tel:${contact.phone.replace(/[\s-]/g, '')}`}
                    style={{ color: '#6b7a8f', fontWeight: 600, textDecoration: 'none' }}
                  >
                    {contact.phone}
                  </a>
                </p>
                <p style={{ fontSize: '12px', color: '#0d1117', fontWeight: 600, margin: 0 }}>
                  Email:{' '}
                  <a
                    href={`mailto:${contact.email}`}
                    style={{ color: '#6b7a8f', fontWeight: 600, textDecoration: 'none' }}
                  >
                    {contact.email}
                  </a>
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
